module.exports = __webpack_public_path__ + "static/media/Arrow 1.cbd6f25f.svg";